export const BackerMenu = [
  {
    title: "Home",
    to: "/",
  },
  {
    title: "About Us",
    to: "/about-us",
  },
  {
    title: "How It Works",
    to: "/how-it-works",
  },
  {
    title: "Projects",
    to: "/project",
  },
  {
    title: "FAQ",
    to: "/faq",
  },
  {
    title: "Contact Us",
    to: "./contact-us",
  },
];
